import React from 'react';
import { ISVGType } from './SVGType';

const LightSmartContractIcon = (props: ISVGType) => {
  const { height="43", width="42" } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 42 43" fill="none">
      <rect opacity="0.3" y="0.5" width="42" height="42" rx="10" fill="#1C1C1C" fillOpacity="0.2"/>
      {/*// @ts-ignore*/}
      <mask id="mask0_687_12822" style={{ 'mask-type':'alpha' }} maskUnits="userSpaceOnUse" x="11" y="12" width="20" height="20">
        <rect x="11" y="12" width="20" height="20" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_687_12822)">
        <path d="M12.667 17V12.8333H16.8337V14.5H14.3337V17H12.667ZM27.667 17V14.5H25.167V12.8333H29.3337V17H27.667ZM12.667 31.1666V27H14.3337V29.5H16.8337V31.1666H12.667ZM25.167 31.1666V29.5H27.667V27H29.3337V31.1666H25.167ZM16.8337 27H25.167V17H16.8337V27ZM16.8337 28.6666C16.3753 28.6666 15.983 28.5035 15.6566 28.1771C15.3302 27.8507 15.167 27.4583 15.167 27V17C15.167 16.5416 15.3302 16.1493 15.6566 15.8229C15.983 15.4965 16.3753 15.3333 16.8337 15.3333H25.167C25.6253 15.3333 26.0177 15.4965 26.3441 15.8229C26.6705 16.1493 26.8337 16.5416 26.8337 17V27C26.8337 27.4583 26.6705 27.8507 26.3441 28.1771C26.0177 28.5035 25.6253 28.6666 25.167 28.6666H16.8337ZM18.5003 20.3333H23.5003V18.6666H18.5003V20.3333ZM18.5003 22.8333H23.5003V21.1666H18.5003V22.8333ZM18.5003 25.3333H23.5003V23.6666H18.5003V25.3333Z" fill="#454545"/>
      </g>
    </svg>
  );
};

export default LightSmartContractIcon;
